import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

function EmptyState({
    message = 'No hay registros para mostrar.',
    className = '',
    compact = false,
}) {
    const classes = ['react-empty-state', compact ? 'is-compact' : '', className]
        .filter(Boolean)
        .join(' ');

    return (
        <Box className={classes} role="status" aria-live="polite">
            <InboxOutlinedIcon className="react-empty-state-icon" aria-hidden="true" />
            <Typography className="react-empty-state-text">{message}</Typography>
        </Box>
    );
}

export default EmptyState;
